// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".datetimepicker[data-v-fceb5082]{position:relative}.datetimeform[data-v-fceb5082]{-webkit-appearance:none;width:100%;height:100%;opacity:0;top:0;left:0}.datetimeform[data-v-fceb5082]::-webkit-calendar-picker-indicator{position:absolute;width:100%;height:100%;opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
